import { render, staticRenderFns } from "./QNewWritersDrilldown.vue?vue&type=template&id=b76e608c&scoped=true&"
import script from "./QNewWritersDrilldown.vue?vue&type=script&lang=js&"
export * from "./QNewWritersDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e608c",
  null
  
)

export default component.exports